import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="tabs"
// Generic content tabs controller for toggling panels within a page (no navigation)
export default class extends Controller {
    static targets = ["button", "panel"]
    static values = {
        default: {type: String, default: null}
    }

    connect() {
        // Determine initial tab
        const initial = this.defaultValue || this.buttonTargets[0]?.dataset.tabName
        if (initial) {
            this.showTab(initial)
        }
    }

    select(event) {
        const name = event.currentTarget.dataset.tabName
        if (!name) return
        this.showTab(name)
    }

    showTab(name) {
        // Toggle button classes
        this.buttonTargets.forEach(btn => {
            const isActive = btn.dataset.tabName === name
            this.toggleButtonClasses(btn, isActive)
        })

        // Toggle panels visibility
        this.panelTargets.forEach(panel => {
            const isActive = panel.dataset.tabName === name
            panel.classList.toggle("hidden", !isActive)
        })
    }

    toggleButtonClasses(button, active) {
        // Base classes are already on the button in markup
        const activeClasses = [
            "border-primary-600",
            "text-primary-600",
            "dark:text-primary-400"
        ]
        const inactiveClasses = [
            "border-transparent",
            "text-slate-600",
            "dark:text-slate-300"
        ]

        if (active) {
            button.classList.add(...activeClasses)
            button.classList.remove(...inactiveClasses)
            button.setAttribute("aria-selected", "true")
            button.tabIndex = 0
        } else {
            button.classList.remove(...activeClasses)
            button.classList.add(...inactiveClasses)
            button.setAttribute("aria-selected", "false")
            button.tabIndex = -1
        }
    }
}
